import { Browser } from "@capacitor/browser";
import { AnchorHTMLAttributes, DetailedHTMLProps } from "react";

type Args = Pick<DetailedHTMLProps<AnchorHTMLAttributes<HTMLAnchorElement>, HTMLAnchorElement>, "onClick"> & {
  href: string;
};

type Return = Pick<
  DetailedHTMLProps<AnchorHTMLAttributes<HTMLAnchorElement>, HTMLAnchorElement>,
  "href" | "onClick" | "rel" | "target"
>;

const useExternalLinkClick = ({ href, onClick }: Args): Return => {
  const anchorProps: Return = {};

  if (href.startsWith("mailto") || href.startsWith("tel")) {
    anchorProps.href = href;
    anchorProps.rel = "noopener noreferrer";
    anchorProps.target = "_blank";
  } else {
    anchorProps.onClick = e => {
      if (onClick) onClick(e);
      Browser.open({ url: href });
    };
  }

  return anchorProps;
};

export default useExternalLinkClick;
